import React,{useEffect,useState} from "react";
import API from "../services/api";
import "../styles/Invoice.css";

export default function SubmittedExpenses(){

const [expenses,setExpenses]=
useState([]);
useEffect(()=>{

fetchExpenses();

},[]);

const fetchExpenses=async()=>{

try{

const employeeName=
localStorage.getItem(
"username"
);

const res=
await API.get(
`/expense?search=${employeeName}`
);

setExpenses(res.data);

}catch(err){

console.log(err);

}

};
return(

<div className="container">

<h1>
Submitted Expenses
</h1>

<table className="invoice-table">

<thead>

<tr>

<th>Invoice #</th>
<th>Customer</th>
<th>Date</th>
<th>Category</th>
<th>Description</th>
<th>Qty</th>
<th>Amount</th>
<th>Total</th>

</tr>

</thead>

<tbody>

{expenses.map(invoice=>(

<React.Fragment
key={invoice.id}
>

{invoice.subItems?.map(
(item,index)=>(

<tr key={index}>

{index===0 && (

<>

<td
rowSpan={
invoice.subItems.length
}
>

{invoice.invoiceNo}

</td>

<td
rowSpan={
invoice.subItems.length
}
>

{invoice.customerName}

</td>

</>

)}

<td>{item.date}</td>

<td>{item.category}</td>

<td className="description-cell">
{item.description}
</td>

<td>{item.quantity}</td>

<td>₹ {item.amount}</td>

<td>₹ {item.total}</td>

</tr>

)

)}

</React.Fragment>

))}

</tbody>

</table>

</div>

);

}